import { useTranslation } from 'react-i18next';
import { TripVersionCompare } from '@koob/trip-designer';
import ProgramRowHeader from './ProgramRowHeader';

// The compare panel is shared; the arrival/departure row it draws is still
// this app's own.
export default function VersionCompare({ tripId }) {
  const { t } = useTranslation('tripDesigner');

  return (
    <TripVersionCompare
      tripId={tripId}
      translation={t}
      renderRowHeader={props => <ProgramRowHeader {...props} />}
    />
  );
}
